import { ComponentView } from "binder";
import { OverlayViewModel } from "./overlay-viewModel"

export class OverlayView extends ComponentView<OverlayViewModel>{
    GetViewUniqueId(): string {
        return "V-04B771C7-F39E-44D1-9188-1F84C1605E0F"
    }
    loadHtml(): string {
        let element = require('./overlay.html').default;
        let style = require('./overlay.less');
        return element;
    }
    constructor() {
       super();
    }
    public set showing(v: boolean) { 
        this._showing = v;
        if(this.firstlevelElement)
            this.updateOverlayStatus();
    } public get showing(): boolean { return this._showing;} private _showing: boolean;
    private updateOverlayStatus(){
        if(this.showing){
            (<HTMLElement>this.firstlevelElement).style.display="block";
            setTimeout(()=>{
                (<HTMLElement>this.firstlevelElement).classList.add("overlay-visible");
            },0);
            this.updateSiblingStatus();
        }else {
            (<HTMLElement>this.firstlevelElement).classList.remove("overlay-visible");
            setTimeout(()=>{
                (<HTMLElement>this.firstlevelElement).style.display="none";
                this.updateSiblingStatus();
            },100)
            
        }
            
    }
    public set contentwidth(v: string) { 
        this._contentwidth = v;
        this.showingcontentwidth = v;
    } public get contentwidth(): string { return this._contentwidth;} private _contentwidth: string;
    public set contentheight(v: string) { 
        this._contentheight = v; 
        this.showingcontentheight = v;
    } public get contentheight(): string { return this._contentheight;} private _contentheight: string;

    public set showingcontentwidth(v: string) { this._showingcontentwidth = v; } public get showingcontentwidth(): string { return this._showingcontentwidth;} private _showingcontentwidth: string;
    public set showingcontentheight(v: string) { this._showingcontentheight = v; } public get showingcontentheight(): string { return this._showingcontentheight;} private _showingcontentheight: string;
    

    onRenderCompleted(){
        this._childrenPlaceholder = this.firstlevelElement.querySelector('.childrenPlaceHolder');
        this._outofChildrenPlaceholder = this.firstlevelElement.querySelector('.outOfChildrenPlaceHolder');
        this.updateOverlayStatus();
        // this._childrenPlaceholder.onclick = e=>{
        //     e.stopImmediatePropagation();
        // }
        (<HTMLElement>this.firstlevelElement).onclick = e=>{
            if(e.target==this._outofChildrenPlaceholder)
                this.requestClosing();
        }
    }
    private _childrenPlaceholder:HTMLElement;
    private _outofChildrenPlaceholder:HTMLElement;
    
    append(...nodes: (Node | string)[]): void{
        this._childrenPlaceholder.append(...nodes);
    }
    requestClosing(){
        this.dataContext.requestClosing();
    }

    updateSiblingStatus(){
        if(this.firstlevelElement){
            let sibling = this.findSibling();
            if(this.showing)
                sibling.forEach(x=>x.setAttribute('inert',''));
            else
                sibling.forEach(x=>x.removeAttribute('inert'));
        }
    }
    findSibling():HTMLElement[]{
        let parent = this.firstlevelElement.parentElement;
        let last = this.firstlevelElement;
        while(parent && parent.childElementCount==1){
            parent = parent.parentElement;
            last = parent;
        }
        let result = [];
        for(let i=0;i<parent.children.length;i++){
            let child = parent.children.item(i);
            if(child!=last){
                result.push(child);
            }
        }
        return result;
    }
    midCreator(t){
        return `1fr ${t} 1fr`;
    }
    midCreatorReverse(t){
        return t.split(' ')[1];
    }
    private _element : Element;

    childrenSubtreeChanged():boolean{
        if(this._element!=null && this._element.isConnected){
            return false;
        }

        let elements = this.firstlevelElement.getElementsByClassName("popup-size-specifier");
        if(elements.length==0){
            this.showingcontentwidth = this.contentwidth;
            this.showingcontentheight = this.contentheight;
            return false;
        }
        let element = elements.item(0);
        this._element = element;
        element.classList.remove('popup-size-specifier');
        let widthAttribute = element.attributes['data-bcustom-width'];
        let heightAttribute = element.attributes['data-bcustom-height'];
        if(widthAttribute !=null && widthAttribute.value !=null){
            this.showingcontentwidth = widthAttribute.value;
        }else{
            this.showingcontentwidth = this.contentwidth;
        }
        if(heightAttribute !=null && heightAttribute.value !=null){
            this.showingcontentheight = heightAttribute.value;
        }else{
            this.showingcontentheight = this.contentheight;
        }
        return false;
    }
}
